import { useState } from "react"
import { useForm } from "react-hook-form"
import { Link } from "react-router"
import { api, ApiError } from "../../lib/api"
import appName from "../../lib/appName"
import "../../styles/auth.scss"

type FormValues = {
  email: string
}

export default function ForgotPasswordPage() {
  const [sent, setSent] = useState(false)

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>()

  const onSubmit = async (data: FormValues) => {
    try {
      await api.post("/users/password", { user: data })
      setSent(true)
    } catch (err) {
      const { data: errData } = err as ApiError
      const message = errData.errors?.[0] ?? "エラーが発生しました"
      setError("root", { message })
    }
  }

  return (
    <div className="auth-layout">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo.png" alt={appName()} className="auth-logo__img" />
        </div>

        <h1 className="auth-title">パスワードをお忘れですか？</h1>
        <p className="auth-subtitle">
          登録したメールアドレスを入力してください
        </p>

        {sent ? (
          <div style={{ textAlign: "center" }}>
            <p style={{ fontSize: 14, color: "#4b5563", lineHeight: 1.75, marginBottom: 24 }}>
              入力したメールアドレス宛にパスワードリセットの手順を送信しました。<br />
              メールをご確認ください。
            </p>
            <div className="auth-footer">
              <Link to="/login">ログインページへ戻る</Link>
            </div>
          </div>
        ) : (
          <>
            {errors.root && (
              <div className="error-banner">{errors.root.message}</div>
            )}

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group">
                <label>メールアドレス</label>
                <input
                  type="email"
                  placeholder="test@example.com"
                  className={errors.email ? "error" : ""}
                  {...register("email", { required: "メールアドレスを入力してください" })}
                />
                {errors.email && <p className="field-error">{errors.email.message}</p>}
              </div>

              <button type="submit" className="btn-primary" disabled={isSubmitting}>
                {isSubmitting ? "送信中..." : "リセットメールを送信"}
              </button>
            </form>

            <div className="auth-footer">
              <Link to="/login">ログインページへ戻る</Link>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
